module.exports = __webpack_public_path__ + "static/media/arrowUp.88713036.svg";